import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSbLogoLightSmall = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 24,
		cy: 24,
		r: 24,
		fill: "#FF6234"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M25.9764 31.2977V16.7021C27.962 15.8713 29.3525 14.0188 29.3525 11.8655C29.3525 8.94352 26.7973 6.56104 23.6572 6.56104C20.5171 6.56104 17.9568 8.93874 17.9568 11.8655C17.9568 14.0188 19.3473 15.8761 21.3329 16.7021V31.2977C19.3473 32.1237 17.9568 33.981 17.9568 36.1343C17.9568 39.0563 20.512 41.4387 23.6572 41.4387C26.8024 41.4387 29.3525 39.061 29.3525 36.1343C29.3525 33.981 27.962 32.1237 25.9764 31.2977ZM23.6572 9.73607C24.9194 9.73607 25.9456 10.691 25.9456 11.8655C25.9456 13.04 24.9194 13.9949 23.6572 13.9949C22.395 13.9949 21.3688 13.04 21.3688 11.8655C21.3688 10.691 22.395 9.73607 23.6572 9.73607ZM23.6572 38.2637C22.395 38.2637 21.3688 37.3088 21.3688 36.1343C21.3688 34.9597 22.395 34.0049 23.6572 34.0049C24.9194 34.0049 25.9456 34.9597 25.9456 36.1343C25.9456 37.3088 24.9194 38.2637 23.6572 38.2637Z",
		fill: "white"
	})]
});
export default SvgSbLogoLightSmall;
